export default {
  "wt-switcher": "_wt-switcher_rv8l0q_1",
  "wt-switcher_theme_light": "_wt-switcher_theme_light_rv8l0q_20",
  "wt-switcher_theme_dark": "_wt-switcher_theme_dark_rv8l0q_25",
  "wt-switcher_size_xs": "_wt-switcher_size_xs_rv8l0q_30",
  "wt-switcher__option": "_wt-switcher__option_rv8l0q_34",
  "wt-switcher_size_m": "_wt-switcher_size_m_rv8l0q_51",
  "wt-switcher_size_s": "_wt-switcher_size_s_rv8l0q_62",
  "wt-switcher_disabled": "_wt-switcher_disabled_rv8l0q_85",
  "wt-switcher__option_selected": "_wt-switcher__option_selected_rv8l0q_112",
  "wt-switcher__mark": "_wt-switcher__mark_rv8l0q_162"
};